import { supabase, requireOrganizationId } from "./supabase";
import { logError } from "./logError";

export type LogActionType = "CREATE" | "UPDATE" | "DELETE" | "MOVE" | "IMPORT";
export type LogEntityType =
  | "PROJECT"
  | "CATEGORY"
  | "SUBCATEGORY"
  | "CLAIM"
  | "VARIATION"
  | "PAYMENT";

interface LogActivityParams {
  projectId?: string;
  actionType: LogActionType;
  entityType: LogEntityType;
  entityId?: string;
  description: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- auto-suppressed for safety
  metadata?: Record<string, any>;
  userId?: string;
}

export const logActivity = async (params: LogActivityParams) => {
  try {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) {
      console.warn("[ActivityLog] No authenticated user found, skipping log.");
      return;
    }

    const { error } = await supabase.from("claims_activity_logs").insert({
      organization_id: requireOrganizationId(),
      project_id: params.projectId,
      user_id: user.id,
      action_type: params.actionType,
      entity_type: params.entityType,
      entity_id: params.entityId,
      description: params.description,
      metadata: params.metadata,
    });

    if (error) {
      logError("[ActivityLog] Failed to log activity:", error);
    }
  } catch (err) {
    logError("[ActivityLog] Unexpected error logging activity:", err);
  }
};
